module.exports = __webpack_public_path__ + "department_white.1ea513ec50b20239695b.svg";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/dummy-assets/common/img/icon/svg_icon/department_white.svg
// module id = ../../../../../src/assets/modules/dummy-assets/common/img/icon/svg_icon/department_white.svg
// module chunks = styles